var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批详情",
            visible: _vm.applyDialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "payRequestContent" },
            [
              _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _c("p", [
                  _vm._v(
                    "提请金额：" +
                      _vm._s(_vm.editObj.price) +
                      _vm._s(_vm.editObj.currency)
                  ),
                ]),
              ]),
              _vm._l(_vm.applyData, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-bottom": "10px" } },
                  [
                    _c("p", [_vm._v("第" + _vm._s(index) + "层")]),
                    _c(
                      "p",
                      [
                        _vm._l(item, function (item1, index1) {
                          return _c(
                            "span",
                            {
                              key: index1,
                              staticStyle: { "margin-right": "10px" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(item1.applyName) +
                                  "   " +
                                  _vm._s(
                                    item1.status === 0
                                      ? "待审核"
                                      : item1.status == 1
                                      ? "已审核"
                                      : "已拒绝"
                                  ) +
                                  " "
                              ),
                              item1.status == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateFormatYMDHMS(
                                          item1.createTime,
                                          "-"
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v("    "),
                      ],
                      2
                    ),
                  ]
                )
              }),
              _vm.editObj.status == 1
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.coutiueApply()
                        },
                      },
                    },
                    [_vm._v("催审")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.applyDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }